const BASE = (process.env.REACT_APP_CMS_URL || '').replace(/\/$/, '');
const TOKEN = process.env.REACT_APP_CMS_TOKEN;

const reqHeaders = {
  'Content-Type': 'application/json',
  ...(TOKEN ? { Authorization: `Bearer ${TOKEN}` } : {}),
};

async function get(path) {
  if (!BASE) return null;
  try {
    const res = await fetch(`${BASE}/api${path}`, { headers: reqHeaders });
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}

// Resolves a Strapi media object's URL to an absolute URL
export function getImageUrl(mediaObj) {
  const url = mediaObj?.data?.attributes?.url;
  if (!url) return null;
  return url.startsWith('http') ? url : `${BASE}${url}`;
}

// Resolves multiple media items
export function getImagesUrls(mediaObj) {
  const items = mediaObj?.data;
  if (!Array.isArray(items)) return [];
  return items.map(item => {
    const url = item?.attributes?.url;
    if (!url) return null;
    return url.startsWith('http') ? url : `${BASE}${url}`;
  }).filter(Boolean);
}

// Extracts attributes from a Strapi v4 item
export function attr(item) {
  return item?.attributes ?? item ?? {};
}

// CMS fetch functions
export const fetchAbout        = () => get('/about?populate=*');
export const fetchSkills       = () => get('/skills?sort=order:asc&pagination[limit]=100');
export const fetchExperiences  = () => get('/experiences?populate=*&sort=start_date:desc');
export const fetchProjects     = () => get('/projects?populate=*&sort=year:desc');
export const fetchEducation    = () => get('/educations?populate=logo&sort=start_date:desc');
export const fetchCertificates = () => get('/certificates?populate=image&sort=issue_date:desc');
export const fetchResearch     = () => get('/research-papers?sort=year:desc');
export const fetchConferences  = () => get('/conferences?sort=date:desc');
export const fetchHackathons   = () => get('/hackathons?sort=date:desc');
export const fetchBlogs        = () => get('/blog-posts?populate=thumbnail&sort=publishedAt:desc&pagination[limit]=6');

export async function submitContact(data) {
  const res = await fetch(`${BASE}/api/contact-submissions`, {
    method: 'POST',
    headers: reqHeaders,
    body: JSON.stringify({ data }),
  });
  if (!res.ok) throw new Error('Submit failed');
  return res.json();
}
